import React from 'react';

import { Accordion } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';

import '../css/Components.css';

const SECTIONS = [
	{
		key: 'declinable',
		title: 'Declinable participles',
		options: [
			{ value: 'ppp',  label: 'past passive participle' },
			{ value: 'pap',  label: 'past active participle' },
			{ value: 'pfap', label: 'perfect active participle' },
			{ value: 'pfmp', label: 'perfect middle participle' },
			{ value: 'pfpp', label: 'perfect passive participle' },
			{ value: 'prap', label: 'present active participle' },
			{ value: 'prmp', label: 'present middle participle' },
			{ value: 'prpp', label: 'present passive participle' },
			{ value: 'fap',  label: 'future active participle' },
			{ value: 'fmp',  label: 'future middle participle' },
			{ value: 'fpp',  label: 'future passive participle' },
			{ value: 'ger',  label: 'gerundive' },
		],
	},
	{
		key: 'indeclinable',
		title: 'Indeclinable participles',
		options: [
			{ value: 'abs',      label: 'absolutive past active' },
			{ value: 'inf',      label: 'infinitive' },
			{ value: 'ppf_actn', label: 'periphrastic perfect action noun' },
		],
	},
];

const LexParticiple = ({ inputParts, setInputParts }) => {
	const updateInput = (key, value) => {
		setInputParts((prev) => ({ ...prev, [key]: value }));
	};

	const selected = inputParts['lexical_category'];

	return (
		<Accordion defaultActiveKey="declinable" flush>
			{SECTIONS.map(({ key, title, options }) => (
				<Accordion.Item eventKey={key} key={key}>
					<Accordion.Header>{title}</Accordion.Header>
					<Accordion.Body>
						<Form.Group>
							{options.map(({ value, label }) => (
								<Form.Check
									key={value}
									id={`lex_ptcp_${value}`}
									type="radio"
									name="lexParticipleCategory"
									label={
										<span className="lex-radio-label">
											<span className="lex-radio-code">{value}</span>
											<span className="lex-radio-text">{label}</span>
										</span>
									}
									checked={selected === value}
									onChange={() => updateInput('lexical_category', value)}
								/>
							))}
						</Form.Group>
					</Accordion.Body>
				</Accordion.Item>
			))}
		</Accordion>
	);
};

export default LexParticiple;
